/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ws_FooterInputs */

const en_settings_ws_footer = /** @type {(inputs: Settings_Ws_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already synced? Open the workspace from each row to see its wiki and plans.`)
};

const id_settings_ws_footer = /** @type {(inputs: Settings_Ws_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah sync? Buka workspace lewat tombol di tiap baris untuk melihat wiki dan rencana di dalamnya.`)
};

/**
* | output |
* | --- |
* | "Already synced? Open the workspace from each row to see its wiki and plans." |
*
* @param {Settings_Ws_FooterInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_ws_footer = /** @type {((inputs?: Settings_Ws_FooterInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ws_FooterInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_ws_footer(inputs)
	return en_settings_ws_footer(inputs)
});